import {sendRequest } from "@infrastructure/api/api";
import type ApiResponse from "@core/types/apiResponse";
import type { ErrorResponse } from "@core/types/errorResponse";
import type { PaginatedReportResponse } from "./types";

export type FetchArgs =
  | {
      scope: "church";
      churchId: number;
      departmentId: number;
      reportTagId: number;
      page?: number;
      perPage?: number;
      lensParams?: Record<string, string>;
    }
  | {
      scope: "district";
      districtId: number;
      departmentId: number;
      reportTagId: number;
      page?: number;
      perPage?: number;
      officePage?: number;
      lensParams?: Record<string, string>;
    }
  | {
      scope: "nation";
      nationId: number;
      departmentId: number;
      reportTagId: number;
      page?: number;
      perPage?: number;
      officePage?: number;
      districtOriginPage?: number;
      lensParams?: Record<string, string>;
    };

function buildPath(args: FetchArgs): string {

  if (args.scope === "church") {
    return `/church/${args.churchId}/department/${args.departmentId}/report/form`;
  }

  if (args.scope === "district") {
    return `/district/${args.districtId}/department/${args.departmentId}/report/form`;
  }

  return `/nation/${args.nationId}/department/${args.departmentId}/report/form`;
}

export async function fetchReportFormAsync(
  args: FetchArgs
): Promise<ApiResponse<PaginatedReportResponse, ErrorResponse>> {
  const page = args.page ?? 1;
  const perPage = args.perPage ?? 20;
  const params: Record<string, string> = {
    reportTagId: String(args.reportTagId),
    page: String(page),
    perPage: String(perPage),
    ...(args.lensParams ?? {}),
  };
  if (args.scope !== "church" && args.officePage != null) {
    params.officePage = String(args.officePage);
  }
  if (args.scope === "nation" && args.districtOriginPage != null) {
    params.districtOriginPage = String(args.districtOriginPage);
  }

  const url = `${buildPath(args)}?` + new URLSearchParams(params).toString();

  return sendRequest<any, PaginatedReportResponse>("GET", url);
}
